module.exports = __webpack_public_path__ + "site/img/91.4b8bd93f.jpg";